import React, { useState, useContext, useEffect } from "react";
import { AIAssistantRoutes } from "./../../Routes";
import { NavLink } from "reactstrap";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import { ProductContext } from "../../store";
import Skeleton from "react-loading-skeleton";
import { isPlatformOverviewPath } from "../../utils/adminRoutes";

const getWebsiteFromData = (websiteData, websiteId) => {
	if (!websiteData || websiteId === null || websiteId === undefined) {
		return null;
	}
	return websiteData[websiteId] ?? websiteData[String(websiteId)] ?? null;
};

const AIAssistantSidebar = () => {
	const [subMenuOpen, setSubMenuOpen] = useState([]);
	const [websitePlatform, setWebsitePlatform] = useState("");
	const location = useLocation();
	const isPlatformOverview = isPlatformOverviewPath(location.pathname);
	const {
		addPageOpen,
		userLoader,
		websiteLoader,
		websiteData,
		currentWebsiteId,
		userWebsitePlan,
		productTypes
	} = useContext(ProductContext);

	useEffect(() => {
		const openMenus = [];
		AIAssistantRoutes.forEach((route) => {
			if (route.subMenu && route.subMenu.length > 0) {
				const hasMatchingSubmenu = route.subMenu.some((subMenu) => {
					const fullPath = route.layout + subMenu.path;
					return (
						location.pathname === fullPath ||
						location.pathname.startsWith(fullPath)
					);
				});
				if (hasMatchingSubmenu) {
					openMenus.push(route.name);
				}
			}
		});
		setSubMenuOpen(openMenus);
	}, [location.pathname]);

	useEffect(() => {
		if (userLoader || !currentWebsiteId) {
			return;
		}

		const website = getWebsiteFromData(websiteData, currentWebsiteId);
		if (website?.websiteType) {
			setWebsitePlatform(website.websiteType);
			return;
		}

		if (!websiteLoader) {
			setWebsitePlatform("shopify");
		}
	}, [currentWebsiteId, userLoader, websiteLoader, websiteData]);

	const handleTopMenu = (e, aiRoute) => {
		if (location.pathname && aiRoute.path && location.pathname !== aiRoute.layout + aiRoute.path) {
			return;
		}
		if (!aiRoute.path) {
			e.preventDefault();
		}
		if (subMenuOpen.indexOf(aiRoute.name) > -1) {
			setSubMenuOpen(subMenuOpen.filter((item) => item !== aiRoute.name));
		} else {
			setSubMenuOpen([...subMenuOpen, aiRoute.name]);
		}
	};

	if (isPlatformOverview) {
		return null;
	}

	return (
		<div className="innerSideBarContainer" style={{ display: addPageOpen ? "none" : "flex" }}>
			<header className="inner-header text-center align-items-center justify-content-start d-flex">
				<i className="fas fa-microchip stl-text-grey-800" style={{ fontSize: "16px", marginLeft: "8px" }}></i>
				<span className="stl-text-grey-800" style={{ marginLeft: "8px", fontSize: "17px", fontWeight: "600" }}>AI Assistant</span>
			</header>
			{websitePlatform === "" ? (
				<>
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
				</>
			) : (
				<nav aria-label="AI Assistant Navigation">
					<ul className="searchNavigationList">
						{AIAssistantRoutes.map((aiRoute, index) => {
							return (
								<React.Fragment key={index}>
									{((!aiRoute.accessPlans || (aiRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some((plan) => aiRoute.accessPlans.includes(plan.planId)))) && (!aiRoute.availablePlatforms || (aiRoute.availablePlatforms && aiRoute.availablePlatforms.includes(websitePlatform))) && (!aiRoute.productType || (aiRoute.productType && productTypes.includes(aiRoute.productType)))) && (
										<li key={index}>
											<NavLink
												to={aiRoute.path ? aiRoute.layout + aiRoute.path : "#"}
												tag={NavLinkRRD}
												className={`navItem ${aiRoute.itemClass ? aiRoute.itemClass : ""}`}
												activeClassName="active"
												onClick={(e) => handleTopMenu(e, aiRoute)}
											>
												<div className="d-flex align-items-center justify-content-between">
													<div className="iconStringWrap">
														<i className={`fas ${aiRoute.fontIcon} text-white`} style={{ fontSize: "14px", marginRight: "8px" }}></i>
														{aiRoute.name}
													</div>
													{aiRoute.subMenu && aiRoute.subMenu.length > 0 && (
														<i className={`fas ${subMenuOpen.indexOf(aiRoute.name) === -1 ? "fa-chevron-right" : "fa-chevron-down"}`} style={{ fontSize: "10px" }} />
													)}
												</div>
											</NavLink>
											{subMenuOpen.indexOf(aiRoute.name) !== -1 && aiRoute.subMenu && aiRoute.subMenu.length > 0 && (
												<div id={"linkGroup" + (index + 1)} className="linkGroup">
													<ul>
														{aiRoute.subMenu.map((subMenu, subIndex) => {
															if (subMenu.menuFlag && (!subMenu.availablePlatforms || (subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform)))) {
																return (
																	<li key={subIndex}>
																		<NavLink
																			to={subMenu.layout + subMenu.path}
																			tag={NavLinkRRD}
																			className={`navItem ${subMenu.itemClass ? subMenu.itemClass : ""}`}
																			activeClassName="active"
																			onClick={(e) => e.stopPropagation()}
																		>
																			{subMenu.name}
																		</NavLink>
																	</li>
																);
															}
															return null;
														})}
													</ul>
												</div>
											)}
										</li>
									)}
								</React.Fragment>
							);
						})}
					</ul>
				</nav>
			)}
		</div>
	);
};

export default AIAssistantSidebar;
